
import React from "react";
import type { Application } from "../../../../core/data/redux/recruitment/types";
import { STAGE_COLORS, LEAN_STATUS_COLORS } from "../../constants/recruitment.constants";

interface StatusCellProps {
    application: Application;
    onEdit: (app: Application) => void;
}

const StatusCell: React.FC<StatusCellProps> = ({ application, onEdit }) => {
    const raw = application.status || "";
    const label =
        application.status_text ||
        raw.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
    const color: string = (LEAN_STATUS_COLORS as any)[raw] || (STAGE_COLORS as any)[raw] || "#64748b";

    return (
        <button
            onClick={(e) => {
                e.stopPropagation();
                onEdit(application);
            }}
            title="Click to update status"
            style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 5,
                padding: "4px 10px 4px 8px",
                borderRadius: 999,
                border: `1px solid ${color}40`,
                background: `${color}14`,
                color,
                fontSize: 11,
                fontWeight: 600,
                cursor: "pointer",
                whiteSpace: "nowrap",
                transition: "filter 0.15s, box-shadow 0.15s",
                outline: "none",
            }}
            onMouseEnter={(e) => {
                (e.currentTarget as HTMLButtonElement).style.filter = "brightness(0.93)";
                (e.currentTarget as HTMLButtonElement).style.boxShadow = `0 0 0 3px ${color}22`;
            }}
            onMouseLeave={(e) => {
                (e.currentTarget as HTMLButtonElement).style.filter = "";
                (e.currentTarget as HTMLButtonElement).style.boxShadow = "";
            }}
        >
            <span
                style={{
                    width: 6,
                    height: 6,
                    borderRadius: "50%",
                    background: color,
                    flexShrink: 0,
                    display: "inline-block",
                }}
            />
            {label}
            <i
                className="ti ti-pencil"
                style={{ fontSize: 10, opacity: 0.6, marginLeft: 2 }}
            />
        </button>
    );
};

export default StatusCell;